import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const AjouteTypeCuisine = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/ajouteTypeCuisine`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const AfficheTypeCuisine = async () => {
    return await axios.get(`${BASE_URL}/api/societe/afficheTypeCuisine`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const SuprimerTypeCuisine = async (idTypeCuisine) => {
    return await axios.delete(`${BASE_URL}/api/societe/deleteTypeCuisine/${idTypeCuisine}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}


const AjouteQuartier = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/ajouteQuartier`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const AfficheQuartier = async () => {
    return await axios.get(`${BASE_URL}/api/societe/afficheQuartier`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const SuprimerQuartier = async (idQuartier) => {
    return await axios.delete(`${BASE_URL}/api/societe/deleteQuartier/${idQuartier}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}






const AjouteCadre = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/ajouteCadre`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const AfficheCadre = async () => {
    return await axios.get(`${BASE_URL}/api/societe/afficheCadre`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const SuprimerCadre = async (idCadre) => {
    return await axios.delete(`${BASE_URL}/api/societe/deleteCadre/${idCadre}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}





const AjouteService = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/ajouteService`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const AfficheService = async () => {
    return await axios.get(`${BASE_URL}/api/societe/afficheService`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const SuprimerService = async (idService) => {
    return await axios.delete(`${BASE_URL}/api/societe/deleteService/${idService}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}







const AjouteRegime = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/ajouteRegime`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const AfficheRegime = async () => {
    return await axios.get(`${BASE_URL}/api/societe/afficheRegime`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const SuprimerRegime = async (idRegime) => {
    return await axios.delete(`${BASE_URL}/api/societe/deleteRegime/${idRegime}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}







const AjoutePayement = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/ajoutePayement`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const AffichePayement = async () => {
    return await axios.get(`${BASE_URL}/api/societe/affichePayement`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const SuprimerPayement = async (idPayement) => {
    return await axios.delete(`${BASE_URL}/api/societe/deletePayement/${idPayement}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}










const AjouteBoisson = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/ajouteBoisson`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const AfficheBoisson = async () => {
    return await axios.get(`${BASE_URL}/api/societe/afficheBoisson`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}
const SuprimerBoisson = async (idBoisson) => {
    return await axios.delete(`${BASE_URL}/api/societe/deleteBoisson/${idBoisson}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}


const AjouteHero = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/ajouteHero`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}



const AfficheHero = async () => {
    return await axios.get(`${BASE_URL}/api/societe/afficheHero`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}


const AjouteCritereAvis = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/ajouteCritereAvis`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}



const AfficheCritereAvis = async () => {
    return await axios.get(`${BASE_URL}/api/societe/afficheCritereAvis`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}

const SuprimerCritere = async (idCritere) => {
    return await axios.delete(`${BASE_URL}/api/societe/deleteCritere/${idCritere}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}

const AjouteRechercheRapide = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/ajouteRechercheRapide`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}


const AfficheRechercheRapide = async () => {
    return await axios.get(`${BASE_URL}/api/societe/afficheRechercheRapide`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}

const AjoutePlusReserver = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/ajoutePlusReserver`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}



const AffichePlusReserver = async () => {
    return await axios.get(`${BASE_URL}/api/societe/affichePlusReserver`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}


const AjoutePromoMin = async (data) => {
    return await axios.post(`${BASE_URL}/api/societe/ajoutePromotionMin`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}



const AffichePromoMin = async () => {
    return await axios.get(`${BASE_URL}/api/societe/affichePromotionMin`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenSociete'),
        }
    });
}


export {
    AjouteTypeCuisine, AfficheTypeCuisine, SuprimerTypeCuisine, AjouteQuartier, AfficheQuartier,
    SuprimerQuartier, AjouteCadre, AfficheCadre, SuprimerCadre, AjouteService, AfficheService, SuprimerService,
    AjouteRegime, AfficheRegime, SuprimerRegime, AjoutePayement, AffichePayement, SuprimerPayement,
    AjouteBoisson, AfficheBoisson, SuprimerBoisson, AjouteHero, AfficheHero, AjouteCritereAvis, AfficheCritereAvis, SuprimerCritere,
    AjouteRechercheRapide, AfficheRechercheRapide, AjoutePlusReserver, AffichePlusReserver, AjoutePromoMin,AffichePromoMin
}